module.exports = __webpack_public_path__ + "static/img/contact.b96e27c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact.png
// module id = 550A
// module chunks = 1